import { Dialog } from "shared/Dialog";
import { AppPinService } from "core/Services/AppPinService";
import { View, ViewData } from "silver";
import { MyonLanguageLoader, LayoutLang } from "Lang";

interface AppDialogViewData extends ViewData {
	lang: LayoutLang;
	intent: string|null;
	pin: string;
	cdn: string;
}

const HTML = `
	<div class="grid {{ intent? | '-columns:2' }}">
		<div class="flex -column -gutter -moat -breezy">
			<div>
				<h3 id="appButtonTitle" class="card_title">{{ lang.TITLE_PIN }}</h3>
			</div>
			<p class="g_noMargin">{{ lang.PIN_READALOUD }}</p>
			<div class="g_bold g_text-xxl flex_item -grow">{{ pin }}</div>
		</div>
		<div class="flex -column -gutter -moat -breezy -alignStart g_separatorLeft" data-myon-if="{{ intent }}">
			<div>
				<h3 class="card_title">{{ lang.SIGN_IN_MOBILE }}</h3>
			</div>
			<div class="flex -row -gutter">
				<p class="g_noMargin">{{ lang.SIGN_IN_MOBILE_MESSAGE }}</p>
				<img data-myon-attr-src="{{ cdn }}img/mobile-icons/android-app-icon.jpg" width="80px" height="80px" class="appDialog_appIcon" aria-hidden="true" />
			</div>
			<a href="{{ intent }}" class="button -secondary">{{ lang.ACTION_SIGN_IN }}</a>
		</div>
	</div>`;

export class AppDialog {

	private promise?: Promise<[ LayoutLang, string, string|null ]>;

	constructor(
		private button: HTMLButtonElement,
		private username: string,
		private buildingId: number,
		private appPinService: AppPinService,
		private langLoader: MyonLanguageLoader,
		private dialog: Dialog,
		private cdn: string
	) {
		this.button.addEventListener("click", () => {
			this.openPopup().catch(console.error);
		});
	}

	private load(): Promise<[ LayoutLang, string, string|null ]> {
		if (!this.promise) {
			this.button.classList.add("-active");
			this.promise = Promise.all([
				this.langLoader.load("Layout"),
				this.appPinService.getPin(),
				this.appPinService.getAppLoginLink(this.username, this.buildingId)
			]);
		}
		return this.promise;
	}

	public async openPopup(): Promise<void> {
		const [ lang, pin, intent ] = await this.load();
		const view = new View<AppDialogViewData>(HTML, { }, {
			lang, pin, intent, cdn: this.cdn
		});

		this.button.classList.remove("-active");

		await this.dialog.alert(lang.TITLE_PIN(), view.element, lang.ACTION_CLOSE(), {
			width:                 intent ? 600 : 400,
			hideTitle:             true,
			sourceElement:         this.button,
			disableBodyFormatting: true,
		});
	}
}
